import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Usage } from '../usage.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class UsagesResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(params?: QueryParams): Observable<Usage> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Usage>(`${this.apiRoot}/${account_id}/api/usage/statistics`, { params })),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Usage', downgradeInjectable(UsagesResource));
